import { AppId, URL_PREFIX_BY_APP_ID } from '../constants';

/**
 * Adds the application prefix to the URL if it is not already present.
 * @param url
 * @param appId
 * @returns string
 */
export const addAppPrefixToUrl = (url: string, appId: AppId) => {
    const prefix = URL_PREFIX_BY_APP_ID[appId];
    const normalisedUrl = `${url.startsWith('/') ? '' : '/'}${url}`;
    // Only add the prefix if it is not already present at the start of the URL
    if (normalisedUrl.startsWith(`/${prefix}`) && appId in URL_PREFIX_BY_APP_ID) {
        return normalisedUrl;
    }

    if (!(appId in URL_PREFIX_BY_APP_ID)) {
        return normalisedUrl;
    }

    return `/${prefix}${normalisedUrl}`;
};
